import React, { useEffect } from "react";
import { getCookies } from "../../../helpers/storage";
import { trackEvent } from "../../../analytics";

const CleartaxIframe = () => {
  const accessToken = getCookies("accessToken");
  const baseUrl = process.env.REACT_APP_CLEARTAX_URL;
  const cleartaxUrl = `${baseUrl}?token=${accessToken}`;
  const isPageViewTracked = React.useRef(false);
  useEffect(() => {
    if (isPageViewTracked.current) return;
    trackEvent("cleartax_webview_opened", {});
    trackEvent("cleartax_discount_page_cta_clicked", {
      cta_for: "proceed_to_ct",
    });
    isPageViewTracked.current = true;
    return () => {
      trackEvent("cleartax_webview_closed", {});
    };
  }, []);
  return (
    <div>
      {
        <iframe
          src={cleartaxUrl}
          style={{ width: "100%", height: "100vh", border: "none" }}
          title="ClearTax Partner"
        />
      }
    </div>
  );
};

export default CleartaxIframe;
